import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import TextField from 'material-ui/TextField';

import Button from 'material-ui/Button';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import IntlMessages from 'util/IntlMessages';
import { CircularProgress } from 'material-ui/Progress';
import { signIn } from 'actions/CustomAuth';
import NewPasswordModal from 'app/routes/components/routes/NewPasswordModal/NewPasswordModal';
import { confirmResetPassword, sendVerificationCode, setFirstTimePassword } from 'util/user-manager';
import { createNotification } from 'util/util';
import { getThemeConfiguration } from 'util/aws-manager';
import * as CONST from 'util/app-constants';

class SignIn extends React.Component {
  constructor() {
    super();
    this.onNewPasswordChange.bind(this);
    this.onConfirmPasswordChange.bind(this);
    this.state = {
      email: '',
      password: '',
      newPassword: '',
      confirmPassword: '',
      verificationCode: '',
      resetToNewPassword: '',
      confirmResetToNewPassword: '',
      username: null,
      isVerificationCodeButtonDisable: false,
      isResetPasswordButtonDisable: true,

    };
  }

  componentDidUpdate() {
    if (this.props.profileInfo.signedIn !== null) {
      this.props.history.push('/');
    }
  }

  componentDidMount() {
    $('.app-main').toggleClass('bg-wrapper');
    $('#signin').toggleClass('d-none');

    this.props.fetchTheme();
  }

  componentWillUnmount() {
    $('.app-main').toggleClass('bg-wrapper');
  }

    onNewPasswordChange = (e) => {
      this.setState({
        newPassword: e.target.value,
      });
    };

    onConfirmPasswordChange = (e) => {
      this.setState({
        confirmPassword: e.target.value,
      });
    };

    checkAndSetPassword = () => {
      if (this.state.newPassword === this.state.confirmPassword) {
        setFirstTimePassword(this.state.newPassword).then(() => {
          NotificationManager.success('Password successfully updated.');
        }, (error) => {
          NotificationManager.error(error.message);
        });
      }
      else {
        createNotification('Password do not match.', 'Error', 'Error');
      }
    };

    toggleToResetPassword = () => {
      $('#signin').toggleClass('d-none');
      $('#forgotPassword').toggleClass('d-none');
    };

    getVerificationCode = () => {
      sendVerificationCode(this.state.username).then(() => {
        NotificationManager.success('Verification Code Sent on your Registered Email');
        this.toggleResetPasswordFields();
        $('#backToSignIn').toggleClass('d-none');
      }, (error) => {
        NotificationManager.error(error.message);
        this.setState({ isVerificationCodeButtonDisable: false });
      });
      this.toggleButtonsState();
    }

    toggleResetPasswordFields = () => {
      $('#resetPasswordFields').toggleClass('d-none');
      // $('#backToSignIn').toggleClass('d-none')
    }

    toggleButtonsState = () => {
      this.setState({

        isVerificationCodeButtonDisable: true,
        isResetPasswordButtonDisable: false,
        isUsernameResetFieldDisable: false,
        verificationCode: null,
        resetToNewPassword: null,
        confirmResetToNewPassword: null,
        username: null,
      });
    }
    resetPasswordFieldsToNull = () => {
      this.setState({

        isUsernameResetFieldDisable: true,
        verificationCode: '',
        resetToNewPassword: '',
        confirmResetToNewPassword: '',

      });
    }

    setNewPassword = () => {
      if (this.state.resetToNewPassword === this.state.confirmResetToNewPassword) {
        confirmResetPassword(this.state.verificationCode, this.state.resetToNewPassword).then(() => {
          NotificationManager.success('Password successfully updated.');
          this.resetToInitialState();
          this.toggleToResetPassword();
          this.toggleResetPasswordFields();
        }, (error) => {
          NotificationManager.error(error.message);
          this.resetPasswordFieldsToNull();
          // this.resetToInitialState();
        });
      }
      else {
        createNotification('Password do not match.', 'Error', 'Error');
        this.resetPasswordFieldsToNull();
        // this.resetToInitialState();
      }
    }

    resetToInitialState = () => {
      this.setState({
        isVerificationCodeButtonDisable: false,
        isResetPasswordButtonDisable: true,
        isUsernameResetFieldDisable: false,
      });
    }

    handleKeyPress = (e) => {
      if (e.key === 'Enter') {
        this.props.authenticate({
          username: this.state.email,
          password: this.state.password,
        }, this.props.profileInfo.themeToApply);
      }
    }

    render() {
      const {
        email,
        password,
      } = this.state;
      const { showMessage, loader, alertMessage } = this.props;
      return (<div
        className="app-login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3"
        id="sign-in"
      >
        <div className="app-login-main-content">

          <div className="app-logo-content d-flex align-items-center justify-content-center">
            <Link className="logo-lg" to="/homePage">
              <img
                className="img-responsive w-100"
                src="/assets/images/Senstra_logo-2.png"
                alt="Symbiotic"
                title="Symbiotic"
              />
            </Link>
          </div>

          <div className="app-login-content">
            <div className="app-login-header mb-4">
              <h1 className="text-dark" id="signin-header"> Log - In </h1>
              {/* <h1><IntlMessages id="appModule.email"/></h1> */}
            </div>

            <div className="app-login-form d-none active" id="signin">
              <form>
                <fieldset>
                  <TextField
                    id="requiredEmail"
                    label="Username"
                    fullWidth
                    onChange={event => this.setState({ email: event.target.value })}
                    defaultValue={email}
                    margin="normal"
                    className="mt-1 my-sm-3"
                    required
                  />
                  <TextField
                    type="password"
                    id="requiredPassword"
                    label={<IntlMessages id="appModule.password" />}
                    fullWidth
                    onKeyPress={this.handleKeyPress.bind(this)}
                    onChange={event => this.setState({ password: event.target.value })}
                    defaultValue={password}
                    margin="normal"
                    className="mt-1 my-sm-3"
                    required
                  />

                  <div className="mb-3 d-flex align-items-center justify-content-between">
                    <Button
                      onClick={() => {
                                        // this.props.showAuthLoader();
                                        this.props.authenticate({
                                            username: this.state.email,
                                            password: this.state.password,
                                        }, this.props.profileInfo.themeToApply);
                                    }}
                      variant="raised"
                      color="primary"
                    >
                      <IntlMessages id="appModule.signIn" />
                    </Button>
                    {/* <a
                      className="link-font-size link-color forgot-password-text"
                      onClick={this.toggleToResetPassword}
                      variant="raised"
                      color="primary"
                    >- Forgot Password -</a>

                    <Link className="link-font-size link-color" to="/signup">
                                        - Sign Up
                                        - </Link> */}
                  </div>
                  <div>                    
                  To get access to a complementary demo,
                  <br></br>
                  <b>
                  Email us at: </b>iot@senstra.com.au
                  </div>
                </fieldset>
              </form>
            </div>
            <div className="app-login-form d-none" id="newPassword">
              <form>
                <fieldset>
                  <TextField
                    type="password"
                    id="newPassword"
                    label={<IntlMessages id="appModule.password" />}
                    fullWidth
                    onChange={(e) => {
                                        this.onNewPasswordChange(e);
                                    }}
                    margin="normal"
                    className="mt-1 my-sm-3"
                    required
                  />
                  <TextField
                    type="password"
                    id="confirmNewPassword"
                    label={<IntlMessages id="appModule.password" />}
                    fullWidth
                    onChange={(e) => {
                                        this.onConfirmPasswordChange(e);
                                    }}
                    margin="normal"
                    className="mt-1 my-sm-3"
                    required
                  />
                  <Button onClick={this.checkAndSetPassword} variant="raised" color="primary">
                                    Update Password
                  </Button>


                </fieldset>
              </form>
            </div>
            <div className="app-login-form d-none" id="forgotPassword">
              <form>
                <fieldset>
                  <TextField
                    id="user"
                    label="Username"
                    fullWidth
                    onChange={event => this.setState({ username: event.target.value })}
                    margin="normal"
                    className="mt-1 my-sm-3"
                    required
                    disabled={this.state.isUsernameResetFieldDisable}
                  />
                  <Button
                    onClick={this.getVerificationCode}
                    disabled={this.state.isVerificationCodeButtonDisable}
                    variant="raised"
                    color="primary"
                  >
                                    Get Verification Code
                  </Button>
                  <Link
                    className="float-right link-color "
                    to="/"
                    id="backToSignIn"
                    onClick={this.toggleToResetPassword}
                  >
                                    Sign In
                  </Link>
                  <div className="d-none" id="resetPasswordFields">
                    <TextField
                      id="verificationCode"
                      label="Verification Code"
                      fullWidth
                      value={this.state.verificationCode}
                      onChange={event => this.setState({ verificationCode: event.target.value })}
                      margin="normal"
                      className="mt-1 my-sm-3"
                      required
                    />
                    <TextField
                      type="password"
                      id="resetPassword"
                      label="Reset Password"
                      fullWidth
                      value={this.state.resetToNewPassword}
                      onChange={event => this.setState({ resetToNewPassword: event.target.value })}
                      margin="normal"
                      className="mt-1 my-sm-3"
                      required
                    />
                    <TextField
                      type="password"
                      id="confirmResetPassword"
                      label="Confirm Reset Password"
                      fullWidth
                      value={this.state.confirmResetToNewPassword}
                      onChange={event => this.setState({ confirmResetToNewPassword: event.target.value })}
                      margin="normal"
                      className="mt-1 my-sm-3"
                      required
                    />
                    <Button
                      onClick={this.setNewPassword}
                      disabled={this.state.isResetPasswordButtonDisable}
                      variant="raised"
                      color="primary"
                    >
                                        Reset Password
                    </Button>
                    <Link
                      className="float-right link-color text-nowrap"
                      to="/"
                      onClick={this.toggleToResetPassword}
                    >
                                        Sign In
                    </Link>
                  </div>

                </fieldset>

              </form>
            </div>
          </div>

        </div>
        {
                loader &&
                <div className="loader-view">
                  <CircularProgress />
                </div>
            }
        {showMessage && NotificationManager.error(alertMessage)}
        <NotificationContainer />
        <NewPasswordModal />
      </div>);
    }
}

const mapStateToProps = ({ auth, profileInfo }) => {
  const {
    loader, alertMessage, showMessage, authUser,
  } = auth;
  return {
    loader, alertMessage, showMessage, authUser, profileInfo, cognitoUser: profileInfo.cognitoUser,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    authenticate: (payload, themeToApply) => {
      dispatch(signIn(payload, themeToApply));
    },
    fetchTheme: () => {
      getThemeConfiguration(CONST.USER_POOL_ID)
        .then((data) => {
          const content = data.themeID;
          const themeColor = JSON.parse(content).theme.name;
          const maPos = JSON.parse(data.layoutHeartbeat).maPosition;
          const layoutHeartbeat = JSON.parse(data.layoutHeartbeat).heartbeatData;
          const linkOfLogo = JSON.parse(data.link).link;
          const linkToLogo = data.linkToLogo
          dispatch({ type: 'CHANGE_THEME_IN_STORE', color: themeColor });
          dispatch({ type: 'CHANGE_HEARTBEAT_LAYOUT', layout: layoutHeartbeat });
          dispatch({ type: 'CHANGE_HEARTBEAT_MA', isRight: maPos });
          dispatch({
              type: 'UPDATE_LOGO_AND_LINK',
              payload: {
                  linkOfLogo: linkOfLogo,
                  linkToLogo: linkToLogo
              }
          });

        }, () => {
          dispatch({ type: 'CHANGE_THEME_IN_STORE', color: 'indigo' });
          dispatch({ type: 'CHANGE_HEARTBEAT_MA', isRight: true });
        });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SignIn);



// WEBPACK FOOTER //
// ./containers/SignIn.js